import { render, staticRenderFns } from "./material_table.vue?vue&type=template&id=6fc90287&scoped=true"
import script from "./material_table.vue?vue&type=script&lang=js"
export * from "./material_table.vue?vue&type=script&lang=js"
import style0 from "./material_table.vue?vue&type=style&index=0&id=6fc90287&prod&lang=less&scoped=true"
import style1 from "./material_table.vue?vue&type=style&index=1&id=6fc90287&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc90287",
  null
  
)

export default component.exports